import React from "react";
import { styled, css } from "styled-components";
import ArrowLeft from "../../icons/ArrowLeft";
import Colors from "../../styles/Colors";
import { ArrowRight } from "../../icons";
import DefaultLinkRenderer from "../DefaultLinkRenderer";
import { rem } from "../../utils";
const StyledNavigationLink = styled.a `
  display: inline-block;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  border-bottom: 1px solid ${Colors.BLACK};
  color: ${Colors.BLACK};

  svg {
    fill: ${Colors.BLACK};
  }
  &:hover {
    border-bottom: 1px solid transparent;
    cursor: pointer;
  }
  ${({ disabled }) => disabled &&
    css `
      cursor: not-allowed;
      color: ${Colors.GRAY};
      pointer-events: none;
      border-bottom: 1px solid transparent;
      svg {
        fill: ${Colors.GRAY};
      }
    `}
`;
const NavigationLinkContent = styled.span `
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 0.25rem;
  font-weight: 300;
  svg {
    position: relative;
    top: -1px;
  }
`;
const NavigationLinkText = styled.span `
  color: inherit;
  ${({ iconAlignment }) => {
    switch (iconAlignment) {
        case "right":
            return css `
          margin-right: ${rem(12)};
        `;
        case "left":
        default:
            return css `
          margin-left: ${rem(12)};
        `;
    }
}}
`;
export const NavigationLink = React.memo(({ children, title, onClick, disabled, type = "next", href, linkRenderer = DefaultLinkRenderer, }) => {
    const Link = linkRenderer;
    return (React.createElement(Link, { AnchorElement: StyledNavigationLink, title: title, type: "button", href: href, onClick: onClick, disabled: disabled, "aria-disabled": disabled },
        React.createElement(NavigationLinkContent, null,
            type === "back" && React.createElement(ArrowLeft, { width: 14, height: 14 }),
            React.createElement(NavigationLinkText, { iconAlignment: type === "back" ? "left" : "right" }, children),
            type === "next" && React.createElement(ArrowRight, { width: 14, height: 14 }))));
});
NavigationLink.displayName = "NavigationLink";
export default NavigationLink;
//# sourceMappingURL=NavigationLink.js.map